<template>
  <div>
    <Header />

    <router-view v-if="!true" />
    <div v-else id="app">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  components: {
    Header: () => import("@/components/Header"),
  },
  data() {
    return {};
  },
  mounted() {
    // восстанавливаем тему при загрузке
    const saved = localStorage.getItem("darkTheme");
    if (saved === "1") {
      this.$root.isDarkMode = true;
      document.body.classList.add("dark-theme");
    }
  },
  methods: {},
};
</script>

<style >
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.btn-primary.disabled,
.btn-primary:disabled {
  background-color: #5e5e5e;
}

body.dark-theme {
  background-color: #121212;
  color: #c5bfbf !important;
}
body.dark-theme a {
  color: #80cbc4;
}
</style>
